import { z } from "zod";
import { UNCOVERED_CLAIM_SORTS } from "@shared/types/corpus/api.ts";

/** What the uncovered claims list shows. It lives in the URL, so a link opens the same view. */
export const uncoveredClaimFiltersSchema = z.object({
  /** What the claims are ranked by first. */
  sort: z.enum(UNCOVERED_CLAIM_SORTS).default("last_asked"),
});

export type UncoveredClaimFilters = z.output<typeof uncoveredClaimFiltersSchema>;
